import type { GridSortModel } from '@mui/x-data-grid-premium';

export const referralsInitialSortModel: GridSortModel = [
  { field: 'openedAtUtc', sort: 'desc' },
];
